import React from "react";
import { Link } from "react-router-dom";

function Nav() {
    return (
        <div>
            <div id="navRight">
                <Link to="/" id="navButtons">
                    <button id="navButtons"><img src='https://i.imgur.com/8NpxX3B.png' alt="home icon" style={{ height: 16 }}></img></button>
                </Link>
            </div>
            <div id="navBottom">
                <a target="_blank" rel="noopener noreferrer" href="https://github.com/ambermichellelynn">
                    <button id="navButtons">
                        <img src="https://cdn-icons-png.flaticon.com/512/25/25231.png" alt="GitHub icon" style={{ height: 27 }}></img>
                    </button>
                </a><br></br>
                <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/amber-martinez-g/">
                    <button id="navButtons">
                        <img src="https://www.edigitalagency.com.au/wp-content/uploads/new-linkedin-logo-white-black-png.png" alt="LinkedIn icon" style={{ height: 28 }}></img>
                    </button>
                </a>
            </div>
        </div>
    )
}

export default Nav;
